import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { Label as AtlaskitLabel } from "@atlaskit/form";
import Select from "@atlaskit/select";

import { useUserContext } from "@/components/user-context";
import { wacToken } from "@/libraries/design/foundations";

import { useSiteActivationContext } from "../../hooks/site-activation-context";
import { Label as SiteActivationLabel } from "../common";

const container = css({
    display: "flex",
    flexDirection: "column",
    gap: "2px"
});

export const TransactionAccountSelector = () => {
    const { transactionAccounts } = useUserContext();
    const {
        isSubmitting,
        selectedTransactionAccountId,
        setSelectedTransactionAccountId
    } = useSiteActivationContext();

    const handleSelectionChange = (
        value: { value: string; label: string } | null
    ) => {
        if (value) {
            setSelectedTransactionAccountId(value.value);
        }
    };

    const selectedValue = transactionAccounts.find(
        (account) => account.id === selectedTransactionAccountId
    );

    const transactionAccountLabel = (
        <FormattedMessage
            id="siteActivation.transactionAccountSelectorLabel"
            defaultMessage="Billing Account"
        />
    );

    return (
        <div css={container} data-testid="transaction-account-select-container">
            <AtlaskitLabel htmlFor="transaction-account-select">
                <SiteActivationLabel>
                    {transactionAccountLabel}
                </SiteActivationLabel>
            </AtlaskitLabel>
            <Select
                inputId="transaction-account-select"
                options={transactionAccounts.map((transactionAccount) => ({
                    label: transactionAccount.number,
                    value: transactionAccount.id
                }))}
                value={
                    selectedValue
                        ? {
                              label: selectedValue.number,
                              value: selectedValue.id
                          }
                        : null
                }
                onChange={handleSelectionChange}
                isDisabled={isSubmitting}
                isRequired={true}
                styles={{
                    control: (rest) => ({
                        ...rest,
                        borderRadius: "21px",
                        fontFamily: wacToken("font.charlie.text"),
                        fontSize: "1rem",
                        padding: "0px 6px"
                    })
                }}
            />
        </div>
    );
};
